import { isForkHireCandidateDetailUnlocked } from './candidateDetailUnlock';

type ContactDisplayInput = {
  stage: string | null | undefined;
  source?: string | null;
  jobStatus?: string | null;
  canViewSensitive?: boolean;
  email?: string | null;
  phone?: string | null;
  location?: string | null;
};

export type ForkHireContactDisplay =
  | { state: 'protected'; label: string; email: null; phone: null; location: null; sourceLabel: null }
  | { state: 'unavailable'; label: string; email: null; phone: null; location: null; sourceLabel: string | null }
  | { state: 'visible'; label: string; email: string | null; phone: string | null; location: string | null; sourceLabel: string | null };

function clean(value: string | null | undefined) {
  const text = String(value ?? '').trim();
  return text || null;
}

function isClosedJob(status: string | null | undefined) {
  return status === 'closed' || status === 'expired';
}

function isEmployerSourced(source: string | null | undefined) {
  return ['uploaded', 'direct', 'manual', 'manual_upload', 'cv_upload', 'candidate_page_cv_review'].includes(String(source ?? '').trim());
}

export function resolveForkHireContactDisplay(input: ContactDisplayInput): ForkHireContactDisplay {
  const sourceLabel = isEmployerSourced(input.source) ? 'Extracted from CV' : null;

  if (!input.canViewSensitive) {
    return { state: 'protected', label: 'Contact restricted', email: null, phone: null, location: null, sourceLabel: null };
  }

  if (input.stage === 'rejected') {
    return { state: 'protected', label: 'Contact restricted for rejected candidate', email: null, phone: null, location: null, sourceLabel: null };
  }

  if (isClosedJob(input.jobStatus) && !isEmployerSourced(input.source)) {
    return { state: 'protected', label: 'Contact hidden because job is closed', email: null, phone: null, location: null, sourceLabel: null };
  }

  if (!isForkHireCandidateDetailUnlocked(input.stage)) {
    return { state: 'protected', label: 'Contact locked until shortlist', email: null, phone: null, location: null, sourceLabel: null };
  }

  const email = clean(input.email);
  const phone = clean(input.phone);
  const location = clean(input.location);

  if (!email && !phone) {
    return { state: 'unavailable', label: 'Contact unavailable', email: null, phone: null, location: null, sourceLabel };
  }

  return { state: 'visible', label: email ?? phone ?? 'Contact visible', email, phone, location, sourceLabel };
}
